import { Input, Select } from 'components';
import { formatMonthDay, parseMonthDay } from 'domain/utils';
import { WidgetProps } from './Widgets';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const Monthday = ({ value, onChange }: WidgetProps<string>) => {
	const { t } = useTranslation(['labels']);

	// Parse the value, if any, it is MM-DD
	const [month, day] = useMemo(() => {
		let month = 1;
		let day = 1;
		if (value && typeof value === 'string' && value.includes('-')) {
			const { month: m, day: d } = parseMonthDay(value);
			month = m;
			day = d;
		}
		return [month, day];
	}, [value]);

	const maxDays = useMemo(() => {
		try {
			// We use 2020 as a leap year
			const maxDays = new Date(2020, month, 0).getDate();
			return maxDays;
		} catch (e) {
			return 31;
		}
	}, [month]);

	const monthNames = useMemo(
		() =>
			new Array(12).fill(0).map((_, i) => {
				return {
					value: i + 1,
					label: new Date(2020, i, 1).toLocaleString('default', {
						month: 'long',
					}),
				};
			}),
		[]
	);

	return (
		<div className='flex w-full items-center justify-start'>
			<fieldset>
				<label
					htmlFor='day'
					className='flex w-[50px] items-center justify-start text-xs'>
					<span>{t('labels:day')}</span>
				</label>
				<Input
					min={1}
					max={maxDays}
					type='number'
					className='w-[50px]'
					value={day}
					onChange={(e) => {
						onChange(formatMonthDay(month.toString(), e.target.value));
					}}
				/>
			</fieldset>
			<fieldset className='ml-2'>
				<label
					htmlFor='month'
					className='flex w-[50px] items-center justify-start text-xs'>
					<span>{t('labels:month')}</span>
				</label>
				<Select
					options={monthNames}
					className='w-[140px]'
					value={monthNames.find((s) => s.value === month)}
					onChange={(e: any) => {
						onChange(formatMonthDay(e.value, day.toString()));
					}}
				/>
			</fieldset>
		</div>
	);
};
